(() => {
  // Sets up inventory logic on a single <variant-picker> element
  function initializeVariantInventory(picker) {
    if (picker.dataset.inventoryInitialized) return; // Already initialized

    const productType = picker.dataset.productType || '';
    const inventoryStatusEl = document.getElementById(`variant-inventory-status-${picker.dataset.sectionId}-${picker.dataset.productId}`);
    const variantsJsonEl = picker.querySelector('[data-variants-json]');
    const stateElement = picker.querySelector('script[type="application/json"]');

    if (!inventoryStatusEl || !variantsJsonEl || !stateElement) return;

    const variants = JSON.parse(variantsJsonEl.textContent);

    const updateInventoryDisplay = () => {
      try {
        const currentVariant = JSON.parse(stateElement.textContent);
        const fullVariantData = currentVariant ? variants.find(v => v.id === currentVariant.id) : null;

        inventoryStatusEl.textContent = '';
        inventoryStatusEl.className = 'variant-inventory-status';

        if (!fullVariantData) return;

        if (fullVariantData.available && fullVariantData.inventory_policy !== 'continue') {
          const inventory = fullVariantData.inventory_quantity;
          
          // [START] MODIFIED FOR PLURALIZATION
          let typeDisplay = '';
          if (productType) {
            // Assumes productType from Shopify is singular (e.g., "Boot", "Shirt")
            if (inventory === 1) {
              typeDisplay = ` ${productType}`;
            } else {
              // Simple pluralization by adding 's'.
              typeDisplay = ` ${productType}s`;
            }
          }
          // [END] MODIFIED FOR PLURALIZATION

          if (inventory > 0 && inventory < 3) {
            inventoryStatusEl.textContent = `Only ${inventory}${typeDisplay} Left`;
            inventoryStatusEl.classList.add('low-stock');
          } else if (inventory >= 3) {
            inventoryStatusEl.textContent = `${inventory}${typeDisplay} in stock`;
            inventoryStatusEl.classList.add('in-stock');
          }
        }
      } catch (e) {
        // State element might be temporarily empty, ignore parsing errors
      }
    };

    const internalObserver = new MutationObserver(updateInventoryDisplay);
    internalObserver.observe(stateElement, { childList: true, characterData: true, subtree: true });

    updateInventoryDisplay();
    picker.dataset.inventoryInitialized = 'true';
  }

  function runInitializationOnPage() {
    document.querySelectorAll('variant-picker:not([data-inventory-initialized])').forEach(initializeVariantInventory);
  }
  
  const mainObserver = new MutationObserver(runInitializationOnPage);
  mainObserver.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInitializationOnPage);
  } else {
    runInitializationOnPage();
  }

  document.addEventListener('shopify:section:load', runInitializationOnPage);
})();